<div class="dashboard-wrapper">
  <div class="card main-card">
    <!-- <div class="header-bar exact-header"> -->
      <!-- <div class="header-row-flex"> -->
        <!-- Hamburger Menu for Mobile -->

        <!-- Chat Icon -->
        <!-- <div class="d-flex justify-space-between  align-items-center">
          <div class="chat-icon-bg">
            <mat-icon class="chat-icon">chat</mat-icon>
          </div> -->
          <!-- <span class="exact-title ">Otter AI</span> -->
           <!-- <span class="exact-title">Interview Panel</span>
        </div>


        <mat-icon class="menu-icon" *ngIf="isMobile" (click)="toggleMenu()">menu</mat-icon> -->
        <!-- Title and Interview Code -->
        <!-- <span class="exact-title">Otter AI</span> -->
        <!-- <span *ngIf="!isMobile" class="exact-code-badge no-break">
          <span class="exact-code-label">Interview Code:</span> 
           <span class="exact-code" [title]="selectedPrompt?.id || selectedPrompt">
            {{ (selectedPrompt?.id || selectedPrompt) | slice:0:6 }}
            <ng-container *ngIf="(selectedPrompt?.id || selectedPrompt)?.length > 6">...</ng-container>
          </span>
          <mat-icon class="mat-icon-copy" [class.animate-copied]="copyInterviewCode" (click)="copyInterviewCode()"
            matTooltip="{{ copied ? 'Copied!' : 'Copy link' }}">
            {{ copied ? 'check_circle' : 'content_copy' }}
          </mat-icon>
        </span> -->


        <!-- Header Actions (Buttons) -->
        <!-- <div *ngIf="!isMobile" class="ml-0 header-actions exact-actions">

          <button class="exact-btn new no-break" (click)="clearSelection()" [disabled]="!selectedPrompt">
            <span class="material-icons">group</span><span class="no-break"> New Interview</span>
          </button>
          <button class="exact-btn logout" (click)="logout()">
            <span class="material-icons">logout</span> Logout
          </button>
        </div> -->
      <!-- </div> -->


      <!-- Dropdown Menu for Mobile (Visible when menu is toggled) -->
      <!-- <div *ngIf="isMobile && menuOpen" class="mobile-menu"> -->
        <!-- <span class="exact-code-badge no-break">
          <span class="exact-code-label">Interview Code:</span>
          <span class="exact-code" [title]="selectedPrompt?.id || selectedPrompt">
            {{ (selectedPrompt?.id || selectedPrompt) | slice:0:6 }}
            <ng-container *ngIf="(selectedPrompt?.id || selectedPrompt)?.length > 6">...</ng-container>
          </span>
          <mat-icon class="mat-icon-copy" [class.animate-copied]="copyInterviewCode" (click)="copyInterviewCode()"
            matTooltip="{{ copied ? 'Copied!' : 'Copy link' }}">
            {{ copied ? 'check_circle' : 'content_copy' }}
          </mat-icon>
        </span> -->
        <!-- <button class="exact-btn new no-break" (click)="clearSelection()" [disabled]="!selectedPrompt">
          <span class="material-icons">group</span><span class="no-break"> New Interview</span>
        </button>
        <button class="exact-btn logout" (click)="logout()">
          <span class="material-icons">logout</span> Logout
        </button>
      </div>
    </div> -->

    <div class="card-content">
      <div class="sidebar">
        <h3 class="sidebar-heading" (click)="isMobile && toggleDropdown()">
          Recent Interview Codes
          <!-- Arrow icon, only visible on small screens (mobile) -->
          <span class="arrow-icon" [ngClass]="{'rotated': isDropdownOpen}" *ngIf="isMobile">
            &#9660; <!-- Downward arrow -->
          </span>
        </h3>

        <!-- Search input -->
        <div class="sidebar-search">
          <span class="material-icons sidebar-search-icon">search</span>
          <input type="text" class="sidebar-search-input" placeholder="Search codes, names, clients..."
            [(ngModel)]="searchQuery" (input)="onSearchInput()" />
        </div>

        <!-- Date range filter (creation date, in your local time) -->
        <div class="sidebar-date-filter">
          <div class="date-filter-field">
            <label class="date-filter-label">From</label>
            <input type="date" class="date-filter-input" [(ngModel)]="fromDate" name="fromDate"
              [max]="toDate || null" (change)="onDateFilterChange()" />
          </div>
          <div class="date-filter-field">
            <label class="date-filter-label">To</label>
            <input type="date" class="date-filter-input" [(ngModel)]="toDate" name="toDate"
              [min]="fromDate || null" (change)="onDateFilterChange()" />
          </div>
          <button type="button" class="date-filter-clear" *ngIf="fromDate || toDate"
            (click)="clearDateFilter()" title="Clear date filter" aria-label="Clear date filter">
            <span class="material-icons">close</span>
          </button>
        </div>

        <!-- Sidebar list template (shared by desktop and mobile) -->
        <ng-template #sidebarListContent>
          <div class="sidebar-list-container">
            <!-- Skeleton loading -->
            <div class="sidebar-list sidebar-list-simple" *ngIf="loadingPrompts">
              <div *ngFor="let item of [1,2,3,4,5,6,7,8,9,10]; let i = index"
                class="sidebar-simple-item skeleton-item animate-in"
                [style.animation-delay]="i * 80 + 'ms'">
                <div class="skeleton-code"></div>
                <div class="skeleton-name"></div>
              </div>
            </div>
            <!-- Actual items -->
            <div class="sidebar-list sidebar-list-simple" *ngIf="!loadingPrompts">
              <div *ngFor="let prompt of displayedPrompts; let i = index"
                class="sidebar-simple-item animate-in"
                [style.animation-delay]="i * 50 + 'ms'"
                [class.selected]="selectedPrompt?.id === prompt.id"
                (click)="navigateToPrompt(prompt.id)" tabindex="0">
                <div class="sidebar-simple-code">{{prompt.id}}</div>
                <div class="sidebar-simple-name">{{prompt.consultantName || prompt.name}}</div>
                <div class="sidebar-simple-date" *ngIf="prompt.timestamp"
                  [title]="(prompt.timestamp | date:'full')">
                  <span class="material-icons sidebar-date-icon">schedule</span>
                  <span>{{ prompt.timestamp | date:'MMM d, y, h:mm a' }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Pagination controls pinned at bottom of sidebar -->
          <div class="sidebar-pagination" *ngIf="!loadingPrompts && totalPages > 0">
            <div class="pagination-row">
              <button class="page-btn" [disabled]="currentPage === 0" (click)="goToPage(currentPage - 1)">&lsaquo;</button>
              <span class="pagination-current">{{ currentPage + 1 }} / {{ totalPages }}</span>
              <button class="page-btn" [disabled]="currentPage >= totalPages - 1" (click)="goToPage(currentPage + 1)">&rsaquo;</button>
              <select class="pagination-select" [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
                <option *ngFor="let s of pageSizeOptions" [ngValue]="s">{{ s }}</option>
              </select>
            </div>
            <div class="pagination-info">
              {{ currentPage * pageSize + 1 }}–{{ currentPage * pageSize + displayedPrompts.length }} of {{ totalElements }}
            </div>
          </div>
        </ng-template>

        <!-- Desktop: always visible -->
        <ng-container *ngIf="!isMobile">
          <ng-container *ngTemplateOutlet="sidebarListContent"></ng-container>
        </ng-container>

        <!-- Mobile: visible when dropdown toggled -->
        <ng-container *ngIf="isMobile && isDropdownOpen">
          <ng-container *ngTemplateOutlet="sidebarListContent"></ng-container>
        </ng-container>
      </div>




      <div class="settings-form mt-4 mb-4">
        <div class="settings-header settings-header-inline">
          <span class="settings-icon"><span class="material-icons">chat</span></span>
          <span class="settings-title">Interview Settings</span>
        </div>
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="form-grid">
            <ng-container *ngFor="let field of fields">
              <div class="form-group"
                [ngClass]="{ 'full-width': field.type === 'select' || field.type === 'textarea' }">
                <label class="label-title" [for]="field.name">
                  {{ field.label }}<span class="astrick">*</span>
                </label>
                <ng-container [ngSwitch]="field.type">
                  <input *ngSwitchCase="'text'" [type]="field.type" [id]="field.name" [formControlName]="field.name"
                    [placeholder]="field.placeholder || ''" />
                  <div *ngSwitchCase="'select'" class="custom-select-wrapper" [id]="field.name">
                    <div class="custom-select-trigger"
                      [class.open]="customSelectOpen[field.name]"
                      [class.has-value]="form.get(field.name)?.value"
                      (click)="toggleCustomSelect(field.name, $event)">
                      <span class="custom-select-value">{{ form.get(field.name)?.value || 'Select ' + field.label }}</span>
                      <span class="custom-select-arrow">
                        <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
                          <path d="M1 1l4 4 4-4" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </span>
                    </div>
                    <div class="custom-select-options" *ngIf="customSelectOpen[field.name]">
                      <div class="custom-select-option"
                        *ngFor="let option of field.options"
                        [class.selected]="form.get(field.name)?.value === option"
                        (click)="selectCustomOption(field.name, option)">
                        {{ option }}
                      </div>
                    </div>
                  </div>
                  <textarea *ngSwitchCase="'textarea'" rows="5" [id]="field.name" [formControlName]="field.name"
                    [placeholder]="field.placeholder || ''"></textarea>
                </ng-container>
              </div>
            </ng-container>
          </div>
          <div class="form-actions">
            <button type="submit" class="btn btn-primary" [disabled]="form.invalid || isSubmitting">
              <ng-container *ngIf="!isSubmitting">{{ selectedPrompt ? 'Start Interview' : 'Create Interview' }}</ng-container>
              <ng-container *ngIf="isSubmitting">
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Submitting...
              </ng-container>
            </button>
          </div>
        </form>
        <div class="form-or-block">
          <div class="form-or-line"></div>
          <div class="form-or-text">OR</div>
          <div class="form-or-line"></div>
        </div>
        <div class="form-direct-chat">
          <div class="form-direct-label">Use interview code to go to chat directly</div>
          <div class="form-direct-row">
            <input class="form-direct-input" type="text" placeholder="Interview Code" [(ngModel)]="directCode"
              name="directCode" (input)="onDirectCodeInput()" (keydown)="onDirectCodeKeydown($event)" maxlength="6" />
            <button class="form-direct-btn" (click)="goToChatWithCode(directCode)">Go to chat</button>
          </div>
          <div *ngIf="directCodeError" style="color: red;" class="form-direct-error">
            Error : {{ directCodeError }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>